import { useContext } from 'react';

import {
  ShippingConfigActionContext,
  ShippingConfigValueContext,
} from './context';

const useShippingConfigValue = () => {
  const context = useContext(ShippingConfigValueContext);
  if (!context) {
    throw new Error(
      'useShippingConfigValue must be used within a <ShippingConfigFormContext />',
    );
  }
  return context;
};

const useShippingConfigAction = () => {
  const context = useContext(ShippingConfigActionContext);
  if (!context) {
    throw new Error(
      'useShippingConfigAction must be used within a <ShippingConfigFormContext />',
    );
  }
  return context;
};

export { useShippingConfigAction, useShippingConfigValue };
